/* FÉNIX R07.91 — CART VISIBILITY GUARD
   El drawer base conserva la única autoridad del toggle del icono de carrito.
   Este guard sólo refuerza la apertura después de una adición confirmada y
   limpia cualquier estilo forzado cuando el drawer se cierra. */
(function(){
  'use strict';

  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function drawer(){ return q('#nmCartDrawer'); }
  function panel(){ return q('#nmCartDrawer .nm-cart-drawer__panel'); }
  function overlay(){ return q('#nmCartDrawer .nm-cart-drawer__overlay'); }

  function clearLegacyCartConflicts(){
    qa('#AjaxifyDrawer.is-visible, #AjaxifyModal.is-visible, .ajaxcart__overlay').forEach(function(el){
      el.classList.remove('is-visible');
      el.style.display = 'none';
      el.style.opacity = '0';
      el.style.visibility = 'hidden';
      el.style.pointerEvents = 'none';
    });
    document.body.classList.remove('ajaxcart--is-visible', 'ajaxify-lock');
  }

  function cleanupForcedState(){
    var d = drawer();
    var p = panel();
    var o = overlay();

    document.documentElement.classList.remove('nm-cart-open');
    document.body.classList.remove('nm-cart-open');

    if (d && !d.classList.contains('nm-open')) {
      d.setAttribute('aria-hidden', 'true');
      d.style.opacity = '';
      d.style.pointerEvents = '';
      d.style.visibility = '';
    }

    if (p && (!d || !d.classList.contains('nm-open'))) {
      p.style.transform = '';
      p.style.webkitTransform = '';
      p.style.opacity = '';
      p.style.visibility = '';
      p.style.pointerEvents = '';
      p.style.display = '';
      p.style.right = '';
      p.style.zIndex = '';
    }

    if (o && (!d || !d.classList.contains('nm-open'))) {
      o.style.opacity = '';
      o.style.visibility = '';
      o.style.pointerEvents = '';
      o.style.zIndex = '';
    }
  }

  function visibleGuard(){
    var d = drawer();
    var p = panel();
    var o = overlay();
    if (!d || !p || !d.classList.contains('nm-open')) return;

    d.setAttribute('aria-hidden', 'false');
    d.style.opacity = '1';
    d.style.pointerEvents = 'auto';
    d.style.visibility = 'visible';

    p.style.transform = 'translateX(0)';
    p.style.webkitTransform = 'translateX(0)';
    p.style.opacity = '1';
    p.style.visibility = 'visible';
    p.style.pointerEvents = 'auto';
    p.style.display = 'flex';
    p.style.right = '0';
    p.style.zIndex = '2';

    if (o) {
      o.style.opacity = '1';
      o.style.visibility = 'visible';
      o.style.pointerEvents = 'auto';
      o.style.zIndex = '1';
    }

    document.documentElement.classList.add('nm-cart-open');
    document.body.classList.add('nm-cart-open');
  }

  function afterConfirmedAdd(){
    clearLegacyCartConflicts();

    setTimeout(function(){
      if (window.nmCartDrawer && typeof window.nmCartDrawer.open === 'function') {
        try { window.nmCartDrawer.open(); } catch(e) {}
      }
      visibleGuard();
    }, 70);

    [180, 320].forEach(function(delay){
      setTimeout(visibleGuard, delay);
    });
  }

  document.addEventListener('nm:cart:added', afterConfirmedAdd, true);

  function observeDrawerState(){
    var d = drawer();
    if (!d || d.dataset.nmR0791Observed === '1') return;
    d.dataset.nmR0791Observed = '1';

    new MutationObserver(function(){
      if (d.classList.contains('nm-open')) {
        visibleGuard();
      } else {
        cleanupForcedState();
      }
    }).observe(d, { attributes:true, attributeFilter:['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawerState, { once:true });
  } else {
    observeDrawerState();
  }

  window.addEventListener('pageshow', function(){
    observeDrawerState();
    var d = drawer();
    if (d && d.classList.contains('nm-open')) visibleGuard();
    else cleanupForcedState();
  });
})();
